import { useState } from 'react';
import { Link } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../profile/styles.css';

export default function ProfileArtistHelpPurchaseOriginalsPage() {
  const t = useTranslations('collectors_help.purchase_originals');
  const [openSections, setOpenSections] = useState({
    buyArtwork: false,
    showcaseArtworks: false,
    securePayments: false,
    pricing: false,
    customsFees: false,
    returns: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/artist-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('buyArtwork')}
            aria-expanded={openSections.buyArtwork}
          >
            <h2>{t('sections.buy_artwork.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.buyArtwork ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.buyArtwork && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.buy_artwork.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.buy_artwork.step_by_step_title')}</h3>
                <ul>
                  <li>{t('sections.buy_artwork.step_by_step_list_1')}</li>
                  <li>{t('sections.buy_artwork.step_by_step_list_2')}</li>
                  <li>{t('sections.buy_artwork.step_by_step_list_3')}</li>
                  <li>{t('sections.buy_artwork.step_by_step_list_4')}</li>
                  <li>{t('sections.buy_artwork.step_by_step_list_5')}</li>
                  <li>{t('sections.buy_artwork.step_by_step_list_6')}</li>
                  <li>{t('sections.buy_artwork.step_by_step_list_7')}</li>
                  <li>{t('sections.buy_artwork.step_by_step_list_8')}</li>
                  <li>{t('sections.buy_artwork.step_by_step_list_9')}</li>
                </ul>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.buy_artwork.cancel_note_title')}</h3>
                <p>{t('sections.buy_artwork.cancel_note_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('showcaseArtworks')}
            aria-expanded={openSections.showcaseArtworks}
          >
            <h2>{t('sections.showcase_artworks.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.showcaseArtworks ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.showcaseArtworks && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.showcase_artworks.p1')}</p>
              <p>{t('sections.showcase_artworks.p2')}</p>
              <ul>
                <li>{t('sections.showcase_artworks.list_1')}</li>
                <li>{t('sections.showcase_artworks.list_2')}</li>
                <li>{t('sections.showcase_artworks.list_3')}</li>
              </ul>

              <div className="artist-help-category__note">
                <h3>{t('sections.showcase_artworks.privacy_tip_title')}</h3>
                <p>{t('sections.showcase_artworks.privacy_tip_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('securePayments')}
            aria-expanded={openSections.securePayments}
          >
            <h2>{t('sections.secure_payments.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.securePayments ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.securePayments && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.secure_payments.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.secure_payments.currency_title')}</h3>
                <ul>
                  <li>{t('sections.secure_payments.currency_list_1')}</li>
                  <li>{t('sections.secure_payments.currency_list_2')}</li>
                </ul>
                <p>{t('sections.secure_payments.p2')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('pricing')}
            aria-expanded={openSections.pricing}
          >
            <h2>{t('sections.pricing.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.pricing ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.pricing && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.pricing.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.pricing.originals_title')}</h3>
                <p>{t('sections.pricing.originals_p1')}</p>
                <p>{t('sections.pricing.originals_p2')}</p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.pricing.limited_editions_title')}</h3>
                <p>{t('sections.pricing.limited_editions_p1')}</p>
                <p>{t('sections.pricing.limited_editions_p2')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('customsFees')}
            aria-expanded={openSections.customsFees}
          >
            <h2>{t('sections.customs_fees.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.customsFees ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.customsFees && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.customs_fees.p1')}</p>
              <p>{t('sections.customs_fees.p2')}</p>
              <ul>
                <li>{t('sections.customs_fees.list_1')}</li>
                <li>{t('sections.customs_fees.list_2')}</li>
                <li>{t('sections.customs_fees.list_3')}</li>
              </ul>

              <div className="artist-help-category__stack">
                <h3>{t('sections.customs_fees.eu_note_title')}</h3>
                <p>{t('sections.customs_fees.eu_note_p1')}</p>
                <p>{t('sections.customs_fees.eu_note_p2')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('returns')}
            aria-expanded={openSections.returns}
          >
            <h2>{t('sections.returns.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.returns ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.returns && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.returns.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.returns.originals_title')}</h3>
                <ul>
                  <li>{t('sections.returns.originals_list_1')}</li>
                  <li>{t('sections.returns.originals_list_2')}</li>
                </ul>
                <p>
                  {t('sections.returns.originals_policy_pre')}{' '}
                  <Link to="/return-and-refund-policy" state={{ fromPath: '/profile/artist-help/purchase-originals' }}>
                    {t('sections.returns.originals_policy_link')}
                  </Link>
                  {t('sections.returns.originals_policy_post')}
                </p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.returns.limited_editions_title')}</h3>
                <p>
                  {t('sections.returns.limited_editions_p1_pre')}{' '}
                  <Link
                    to="/limited-editions-return-and-refund-policy"
                    state={{ fromPath: '/profile/artist-help/purchase-originals' }}
                  >
                    {t('sections.returns.limited_editions_link')}
                  </Link>
                  {t('sections.returns.limited_editions_p1_post')}
                </p>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.returns.issue_title')}</h3>
                <p>{t('sections.returns.issue_p1')}</p>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.returns.eu_note_title')}</h3>
                <p>{t('sections.returns.eu_note_p1')}</p>
                <p>{t('sections.returns.eu_note_p2')}</p>
              </div>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
